import moment from 'moment';

export const dateFormatter = {
  filters: {
    dateTime(value) {
      return moment(value).format('lll');
    },
    monthYear(value) {
      return moment(value).format('MMM YY');
    },
  },
};